import React from 'react';
import { X } from 'lucide-react';

const ModalShell = ({
  title,
  subtitle,
  icon: Icon,
  onClose,
  children,
  footer,
  maxWidth = 'max-w-lg',
  bodyClassName = '',
}) => (
  <div className="ui-modal-overlay" onClick={onClose} role="presentation">
    <div
      className={`ui-modal-panel ${maxWidth}`}
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="ui-modal-header">
        <div className="flex items-center gap-3 min-w-0">
          {Icon && (
            <div className="w-10 h-10 rounded-xl bg-earth/25 text-tiger flex items-center justify-center shrink-0">
              <Icon size={18} />
            </div>
          )}
          <div className="min-w-0">
            <h2 id="modal-title" className="ui-modal-title truncate">{title}</h2>
            {subtitle && <p className="ui-modal-subtitle">{subtitle}</p>}
          </div>
        </div>
        <button type="button" onClick={onClose} className="ui-modal-close" aria-label="Close">
          <X size={18} />
        </button>
      </div>

      <div className={`ui-modal-body ${bodyClassName}`}>{children}</div>

      {footer && <div className="ui-modal-footer">{footer}</div>}
    </div>
  </div>
);

export default ModalShell;
